import { z } from 'zod';

export const ReportScheduleScalarFieldEnumSchema = z.enum(['reportscheduleId','cityId','personId','emailFrequency','emailDay','reportId','classificationId','dataPeriod','emailIfEmpty']);

export default ReportScheduleScalarFieldEnumSchema;
